/* Creekside product page behaviour. Real cart via /cart/add.js, then Stiletto's quick cart opens.
   Without JS the form posts to /cart/add normally. Re-initialises on Theme Editor section load. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  function openCart() {
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    var icon = document.querySelector('[data-js-cart-icon]');
    var trigger = icon && (icon.closest('a, button') || icon);
    if (document.querySelector('.quick-cart') && trigger) { setTimeout(function () { trigger.click(); }, 350); return true; }
    return false;
  }

  function initMain(el) {
    if (el.__ckp) return; el.__ckp = true;
    var form = $('[data-ckp-form]', el); if (!form) return;
    var L = {}; try { L = JSON.parse(($('[data-ckp-labels]', el.parentNode) || {}).textContent || '{}'); } catch (e) {}
    var freeShip = Number(el.getAttribute('data-free-ship') || 0);
    var cartTotal = Number(L.cartTotal || 0), inCart = false;
    var qty = $('[data-ckp-qty]', form);
    var addBtn = $('[data-ckp-add]', form), addLabel = $('[data-ckp-add-label]', form);
    var main = $('#ckpMain', el);
    var thumbs = $$('[data-ckp-thumb]', el);

    function current() { return $('input[name="id"]:checked', form) || $('input[name="id"]', form); }

    function swap(btn) {
      if (!main || !btn) return;
      thumbs.forEach(function (t) { t.classList.toggle('on', t === btn); });
      if (main.getAttribute('src') === btn.dataset.src) return;
      main.classList.add('fade');
      var img = new Image();
      img.onload = function () { main.removeAttribute('srcset'); main.src = btn.dataset.src; if (btn.dataset.srcset) main.srcset = btn.dataset.srcset; main.classList.remove('fade'); };
      img.src = btn.dataset.src;
    }
    thumbs.forEach(function (b) { b.addEventListener('click', function () { swap(b); }); });

    function update(fromChange) {
      var v = current(); if (!v) return;
      var price = Number(v.dataset.price), compare = Number(v.dataset.compare || 0), count = Number(v.dataset.count || 1);
      var stock = Number(v.dataset.stock), avail = v.dataset.available === 'true';
      var max = stock > 0 ? stock : 999;
      var q = Math.max(1, Math.min(Number(qty.value) || 1, max)); qty.value = q; qty.max = max;
      $('[data-ckp-price]', el).textContent = money(price);
      var cmp = $('[data-ckp-compare]', el);
      if (compare > price) { cmp.textContent = money(compare); cmp.hidden = false; } else { cmp.hidden = true; }
      var per = $('[data-ckp-per]', el);
      per.textContent = L.isCigar ? (count > 1 ? money(Math.round(price / count)) + ' ' + L.perCigar : (v.dataset.title && /single/i.test(v.dataset.title) ? L.perCigar : '')) : '';
      var st = $('[data-ckp-stock]', el), stt = $('[data-ckp-stock-text]', el);
      st.classList.remove('low', 'out');
      if (!avail) { st.classList.add('out'); stt.textContent = L.soldOut; }
      else if (stock > 0 && stock <= 5) { st.classList.add('low'); stt.textContent = (L.onlyLeft || '').replace('[count]', stock); }
      else { stt.textContent = L.inStock; }
      addBtn.disabled = !avail;
      addLabel.textContent = avail ? L.add + (q > 1 || price ? ' · ' + money(price * q) : '') : L.soldOut;
      $$('[data-ckp-ship]', el).forEach(function (s) {
        var left = freeShip - cartTotal - (inCart ? 0 : price * q);
        s.textContent = left > 0 ? (L.shipMore || '').replace('[amount]', money(left)) : L.shipFree;
      });
      var sv = $('[data-ckp-sticky-v]', el);
      if (sv) sv.textContent = (v.dataset.title ? v.dataset.title + ' · ' : '') + money(price);
      var sa = $('[data-ckp-sticky-add]', el); if (sa) sa.disabled = !avail;
      if (fromChange) {
        if (v.dataset.mediaId) { var t = thumbs.filter(function (b) { return b.dataset.mediaId === v.dataset.mediaId; })[0]; if (t) swap(t); }
        try { var u = new URL(location.href); u.searchParams.set('variant', v.value); history.replaceState(null, '', u.toString()); } catch (e) {}
      }
    }
    $$('input[name="id"]', form).forEach(function (i) { i.addEventListener('change', function () { inCart = false; update(true); }); });
    $$('[data-ckp-q]', form).forEach(function (b) { b.addEventListener('click', function () { qty.value = (Number(qty.value) || 1) + Number(b.dataset.ckpQ); inCart = false; update(); }); });
    qty.addEventListener('input', function () { inCart = false; update(); });
    update();

    form.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter !== addBtn && !e.submitter.hasAttribute('data-ckp-add')) return;
      e.preventDefault();
      if (addBtn.getAttribute('aria-busy') === 'true') return;
      var err = $('[data-ckp-err]', el); err.hidden = true;
      addBtn.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
        .then(function () {
          fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cartTotal = c.total_price; inCart = true; update(); }).catch(function () {});
          if (!openCart()) { addBtn.classList.add('done'); addLabel.textContent = L.added; setTimeout(function () { addBtn.classList.remove('done'); update(); }, 1600); }
        })
        .catch(function (x) { err.textContent = x.message; err.hidden = false; })
        .then(function () { addBtn.removeAttribute('aria-busy'); });
    });

    // jump links
    $$('[data-ckp-jump]', el).forEach(function (a) {
      a.addEventListener('click', function (e) { var t = document.querySelector(a.dataset.ckpJump); if (!t) return; e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    });

    // sticky add (mobile)
    var sticky = $('[data-ckp-sticky]', el), atc = $('.ckp-atc', el);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', String(!show));
        $('[data-ckp-sticky-add]', sticky).tabIndex = show ? 0 : -1;
      }).observe(atc);
      $('[data-ckp-sticky-add]', sticky).addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); });
    }
  }

  function initVideos(el) {
    if (el.__ckp) return; el.__ckp = true;
    var player = $('[data-ckp-player]', el); if (!player) return;
    var poster = $('[data-ckp-poster]', player);
    if (poster && poster.dataset.hi) {
      var hi = new Image(); hi.onload = function () { if (hi.naturalWidth > 200) poster.src = poster.dataset.hi; }; hi.src = poster.dataset.hi;
    }
    function embed(id) {
      var old = $('iframe, .ckp-poster', player);
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?rel=0&modestbranding=1&playsinline=1&autoplay=1';
      f.title = 'Creekside Podcast video';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.allowFullscreen = true;
      old.replaceWith(f);
    }
    player.addEventListener('click', function (e) { var p = e.target.closest('.ckp-poster'); if (p) embed(p.dataset.ckpPlay); });
    $$('[data-ckp-eps] button', el).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-ckp-eps] button', el).forEach(function (x) { x.classList.toggle('on', x === b); });
        $('[data-ckp-now-ep]', el).textContent = b.dataset.ep;
        $('[data-ckp-now-title]', el).textContent = b.dataset.title;
        var shop = $('[data-ckp-now-shop]', el);
        if (b.dataset.shop) { shop.href = b.dataset.shop; shop.hidden = false; } else { shop.hidden = true; }
        embed(b.dataset.id);
        if (window.innerWidth < 900) player.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function initStory(el) {
    if (el.__ckp) return; el.__ckp = true;
    var more = $('[data-ckp-more]', el.parentNode); if (!more) return;
    var label = more.textContent;
    el.setAttribute('data-collapsed', '');
    more.addEventListener('click', function () {
      var c = el.toggleAttribute('data-collapsed');
      more.textContent = c ? label : (more.dataset.less || 'Show less');
    });
  }

  function initRecs(el) {
    if (el.__ckp || el.hasAttribute('data-done')) return; el.__ckp = true;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var fresh = d.querySelector('[data-ckp-recs]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  function init(scope) {
    $$('[data-ckp]', scope).forEach(initMain);
    $$('.ckp-watch-wrap', scope).forEach(initVideos);
    $$('[data-ckp-story]', scope).forEach(initStory);
    $$('[data-ckp-recs]', scope).forEach(initRecs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
